// // Fichier : ./App/Animations.js
import { animationMap } from "./Animations/index.js";

export default class Animations {
  constructor(container) {
    this.container = container;

    // Stocker les instances d'animation pour un nettoyage ultérieur
    this.animations = [];

    this.init();
  }

  init() {
    const elementsToAnimate =
      this.container.querySelectorAll("[data-animation]");

    elementsToAnimate.forEach((element) => {
      const animationName = element.dataset.animation;
      const animationClass = animationMap[animationName];

      if (animationClass) {
        const animationInstance = new animationClass(element);
        this.animations.push(animationInstance);
      } else {
        return
      }
    });
  }

  start() {
    this.animations.forEach((animationInstance) => {
      if (animationInstance.start) {
        animationInstance.start();
      }
    });
  }

  kill() {
    // On tue chaque instance d'animation
    this.animations.forEach((animationInstance) => {
      if (animationInstance.kill) {
        animationInstance.kill();
      }
    });

    // On vide le tableau des animations
    this.animations = [];
  }
}
